import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';

dayjs.extend(customParseFormat);

export const convertAssistantData = ({ period, action, isDirect, username }) => {
  const scope = isDirect ? 'direct_only' : 'full_structure';

  const payload = { action, scope };
  const from = period?.from && dayjs(period.from).isValid() ? dayjs(period.from).format('YYYY-MM-DD') : null;
  const to = period?.to && dayjs(period.to).isValid() ? dayjs(period.to).format('YYYY-MM-DD') : null;

  if (from && to) {
    payload.date_from = from;
    payload.date_to = to;
  }

  if (username) payload.username = username;

  return payload;
};
